import { Facebook, Instagram } from 'lucide-react'

export function SiteFooter() {
  return (
    <footer className="border-border bg-background border-t py-8">
      <div className="text-muted-foreground mx-auto flex max-w-7xl flex-col items-center gap-4 px-4 text-center text-sm">
        <div className="flex items-center gap-4">
          <a
            href="https://instagram.com/fairmeadow.capital"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Fairmeadow Capital on Instagram"
            className="hover:text-primary flex h-11 w-11 items-center justify-center transition-colors"
          >
            <Instagram className="h-5 w-5" />
          </a>
          <a
            href="https://www.facebook.com/fairmeadowcapitalrealestate"
            target="_blank"
            rel="noopener noreferrer"
            aria-label="Fairmeadow Capital on Facebook"
            className="hover:text-primary flex h-11 w-11 items-center justify-center transition-colors"
          >
            <Facebook className="h-5 w-5" />
          </a>
        </div>
        <p>&copy; {new Date().getFullYear()} Fairmeadow Capital. All rights reserved.</p>
      </div>
    </footer>
  )
}
